import type { Schemas } from '@argzombie/api-client';
import { when } from '../lib/datetime';
import { countdown, sortConditions } from '../lib/playerSupport';

const th = 'px-2 py-1 text-left';
const td = 'px-2 py-1';

/**
 * The player's survivor conditions (ADR 0031) on the player detail: the current run's active injuries and sickness first, with when
 * they end (or a bite's turning time), then the recent history (healed, treated, turned, cleared).
 */
export function ConditionsTable({
  rows,
}: {
  rows: Schemas['AdminConditionRow'][] | null | undefined;
}) {
  const sorted = sortConditions(rows);
  if (sorted.length === 0)
    return <p className="mt-2 text-xs text-bruise">No conditions this run.</p>;
  return (
    <table className="mt-2 w-full text-xs">
      <thead className="text-bruise">
        <tr>
          <th className={th}>Who</th>
          <th className={th}>Condition</th>
          <th className={th}>Cause</th>
          <th className={th}>Started</th>
          <th className={th}>Progress</th>
          <th className={th}>Ends / turns</th>
          <th className={th}>Resolved</th>
        </tr>
      </thead>
      <tbody>
        {sorted.map((r) => {
          const active = r.resolvedAt == null;
          return (
            <tr
              key={r.id}
              className={`border-t border-newsprint align-top ${active ? 'font-semibold' : 'text-bruise'}`}
            >
              <td className={td}>
                {r.name}
                {r.memberId === 'player' ? ' (player)' : ''}
              </td>
              <td className={td}>
                {r.conditionId}
                {r.turnedAt && (
                  <span className="ml-1 rounded bg-blam px-1 text-white">50% max HP</span>
                )}
              </td>
              <td className={td}>
                {r.cause}
                {r.raidId ? (
                  <span className="ml-1 font-mono">raid {r.raidId.slice(0, 8)}</span>
                ) : null}
              </td>
              <td className={`${td} font-mono`}>{when(r.startedAt)}</td>
              <td className={td}>{Math.round(r.progress * 100)}%</td>
              <td className={td}>
                {active && r.endsAt && `heals ${countdown(r.endsAt)}`}
                {active && !r.endsAt && r.turnsAt && !r.turnedAt && `turns ${countdown(r.turnsAt)}`}
                {active && !r.endsAt && !r.turnsAt && 'needs a cure'}
              </td>
              <td className={td}>
                {active
                  ? 'active'
                  : `${r.resolution ?? ''}${r.itemId ? ` (${r.itemId})` : ''} ${when(r.resolvedAt)}`}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
